/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsOsvVulnerabilityAffectedPackageDetails {
    getFixupPrototypeFunction() { return AppSecopsOsvVulnerabilityAffectedPackageDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsOsvVulnerabilityAffectedPackageDetails>): AppSecopsOsvVulnerabilityAffectedPackageDetails {
        let obj = Object.assign(new AppSecopsOsvVulnerabilityAffectedPackageDetails(), model);
        AppSecopsOsvVulnerabilityAffectedPackageDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsOsvVulnerabilityAffectedPackageDetails>): AppSecopsOsvVulnerabilityAffectedPackageDetails {
        if (!model) return null;
        return AppSecopsOsvVulnerabilityAffectedPackageDetails.newInstance(<AppSecopsOsvVulnerabilityAffectedPackageDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsOsvVulnerabilityAffectedPackageDetails) {
        if (!obj) return;

        models.AppSecopsOsvVulnerabilityAffectedPackageDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsOsvVulnerabilityAffectedPackageDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsOsvVulnerabilityAffectedPackageDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the package
     */
    name: string;

    /**
     * Ecosystem of the package
     */
    ecosystem: string;

    /**
     * Package URL
     */
    purl: string;

}
